import { render, staticRenderFns } from "./base-oss-upload.vue?vue&type=template&id=0cc12e5d&scoped=true"
import script from "./base-oss-upload.vue?vue&type=script&lang=js"
export * from "./base-oss-upload.vue?vue&type=script&lang=js"
import style0 from "./base-oss-upload.vue?vue&type=style&index=0&id=0cc12e5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc12e5d",
  null
  
)

export default component.exports